import { LinearGradient } from "expo-linear-gradient";
import { memo } from "react";
import { View } from "react-native";
import MiniCard, { MINI_CARD_HEIGHT } from "src/components/MiniCard";
import { paddingLarge, paddingMedium } from "src/styles/spacing";
import { GatheringHeaderWideMiniCardsProps } from "./types";

const gradientOverflow = paddingLarge;
const GatheringHeaderWideMiniCards = ({
	miniCards,
	backgroundColor,
}: GatheringHeaderWideMiniCardsProps) => {
	return (
		<View>
			<View
				style={{
					width: `calc(100% + ${gradientOverflow}px)` as any,
					marginHorizontal: -gradientOverflow,
					paddingHorizontal: gradientOverflow,

					height: MINI_CARD_HEIGHT,
					maxHeight: MINI_CARD_HEIGHT,
					marginTop: paddingMedium,
					flexDirection: "row",
					overflow: "scroll",
					// @ts-expect-error
					scrollbarWidth: "none",
				}}
			>
				<View
					style={{
						flexDirection: "row",
						gap: paddingMedium,
					}}
				>
					{miniCards.map((card, index) => (
						<MiniCard key={`${card.title}-${card.variant}-${index}`} {...card} />
					))}
				</View>
			</View>
			<LinearGradient
				colors={[backgroundColor, "transparent"]}
				style={{
					position: "absolute",
					height: "100%",
					left: -gradientOverflow,
					width: gradientOverflow,
				}}
				start={{
					x: 0,
					y: 0,
				}}
				end={{
					x: 1,
					y: 0,
				}}
			/>
			<LinearGradient
				colors={["transparent", backgroundColor]}
				style={{
					position: "absolute",
					height: "100%",
					right: 0,
					width: gradientOverflow,
				}}
				start={{
					x: 0,
					y: 0,
				}}
				end={{
					x: 1,
					y: 0,
				}}
			/>
		</View>
	);
};
export default memo(GatheringHeaderWideMiniCards);
